import React, { Component } from 'react'

class LoadingText extends React.Component {
  constructor(props) {
  super(props);
    this.state = {
      
    };
  }

  render() {
    return (
      <img src="images/graphic-text/mmmm.svg" alt="Mmmm..." />
    );
  }
}

export default LoadingText



// WEBPACK FOOTER //
// ./src/scripts/components/LoadingText.js